import { alwaysTrue } from 'utils/data';

import { TableCellId, tableCellWidthMap } from './Consent.constants';

export const consentTableConfig = {
  [TableCellId.FULL_NAME]: {
    label: 'Full Name',
    width: tableCellWidthMap[TableCellId.FULL_NAME],
    renderContentAsText: alwaysTrue,
    content: ({ [TableCellId.FULL_NAME]: cellData }) => cellData,
  },
  [TableCellId.PARTY]: {
    label: 'Party',
    width: tableCellWidthMap[TableCellId.PARTY],
    renderContentAsText: alwaysTrue,
    content: ({ [TableCellId.PARTY]: cellData }) => cellData,
  },
  [TableCellId.E_CONSENT]: {
    label: 'E-Consent',
    width: tableCellWidthMap[TableCellId.E_CONSENT],
    renderContentAsText: alwaysTrue,
    content: ({ [TableCellId.E_CONSENT]: cellData }) => cellData,
  },
  [TableCellId.CREDIT_CONSENT]: {
    label: 'Credit Consent',
    width: tableCellWidthMap[TableCellId.CREDIT_CONSENT],
    renderContentAsText: alwaysTrue,
    content: ({ [TableCellId.CREDIT_CONSENT]: cellData }) => cellData,
  },
};
